import _classCallCheck from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/vercel/workpath2/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { request } from '@octokit/request';
import { getUserAgent } from 'universal-user-agent';
var VERSION = "4.6.1";

var GraphqlError = /*#__PURE__*/function (_Error) {
  _inherits(GraphqlError, _Error);

  var _super = _createSuper(GraphqlError);

  function GraphqlError(request, response) {
    var _this;

    _classCallCheck(this, GraphqlError);

    var message = response.data.errors[0].message;
    _this = _super.call(this, message);
    Object.assign(_assertThisInitialized(_this), response.data);
    Object.assign(_assertThisInitialized(_this), {
      headers: response.headers
    });
    _this.name = "GraphqlError";
    _this.request = request; // Maintains proper stack trace (only available on V8)

    /* istanbul ignore next */

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    }

    return _this;
  }

  return GraphqlError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var NON_VARIABLE_OPTIONS = ["method", "baseUrl", "url", "headers", "request", "query", "mediaType"];
var FORBIDDEN_VARIABLE_OPTIONS = ["query", "method", "url"];
var GHES_V3_SUFFIX_REGEX = /\/api\/v3\/?$/;

function graphql(request, query, options) {
  if (options) {
    if (typeof query === "string" && "query" in options) {
      return Promise.reject(new Error("[@octokit/graphql] \"query\" cannot be used as variable name"));
    }

    for (var key in options) {
      if (!FORBIDDEN_VARIABLE_OPTIONS.includes(key)) continue;
      return Promise.reject(new Error("[@octokit/graphql] \"".concat(key, "\" cannot be used as variable name")));
    }
  }

  var parsedOptions = typeof query === "string" ? Object.assign({
    query: query
  }, options) : query;
  var requestOptions = Object.keys(parsedOptions).reduce(function (result, key) {
    if (NON_VARIABLE_OPTIONS.includes(key)) {
      result[key] = parsedOptions[key];
      return result;
    }

    if (!result.variables) {
      result.variables = {};
    }

    result.variables[key] = parsedOptions[key];
    return result;
  }, {}); // workaround for GitHub Enterprise baseUrl set with /api/v3 suffix
  // https://github.com/octokit/auth-app.js/issues/111#issuecomment-657610451

  var baseUrl = parsedOptions.baseUrl || request.endpoint.DEFAULTS.baseUrl;

  if (GHES_V3_SUFFIX_REGEX.test(baseUrl)) {
    requestOptions.url = baseUrl.replace(GHES_V3_SUFFIX_REGEX, "/api/graphql");
  }

  return request(requestOptions).then(function (response) {
    if (response.data.errors) {
      var headers = {};

      for (var _i = 0, _Object$keys = Object.keys(response.headers); _i < _Object$keys.length; _i++) {
        var _key = _Object$keys[_i];
        headers[_key] = response.headers[_key];
      }

      throw new GraphqlError(requestOptions, {
        headers: headers,
        data: response.data
      });
    }

    return response.data.data;
  });
}

function withDefaults(request$1, newDefaults) {
  var newRequest = request$1.defaults(newDefaults);

  var newApi = function newApi(query, options) {
    return graphql(newRequest, query, options);
  };

  return Object.assign(newApi, {
    defaults: withDefaults.bind(null, newRequest),
    endpoint: request.endpoint
  });
}

var graphql$1 = withDefaults(request, {
  headers: {
    "user-agent": "octokit-graphql.js/".concat(VERSION, " ").concat(getUserAgent())
  },
  method: "POST",
  url: "/graphql"
});

function withCustomRequest(customRequest) {
  return withDefaults(customRequest, {
    method: "POST",
    url: "/graphql"
  });
}

export { graphql$1 as graphql, withCustomRequest };